import React, { useEffect, useState } from "react";
import { Modal, Button, Checkbox, Input } from "antd";
import { useSelector } from "react-redux";
import crossIcon from "../../assets/Icons/crossIcon.svg";
import searchIcon from "../../assets/Icons/input-search-icon.svg";
import "./ActionHeader.scss";

const categories = [
  { title: "Team Member", value: "team_member" },
  { title: "Team Leader", value: "team_leader" },
];

const ChartFilterModal = ({
  setPrimaryItems,
  setSecondaryItems,
  secondaryItems = [],
  primaryItems,
  setOpen,
  open,
  selectedTrustMap,
  setSelectedTrustMap,
  selectedCategory,
  setSelectedCategory,
  setRefresh,
}) => {
  const [selectedFilterList, setSelectedFilterList] = useState([]);

  const [error, setError] = useState("");

  const { filter_list,analyse_filters } = useSelector((state) => state?.filters);

  // Toggle trust while ensuring only one category is selected
  const toggleTrust = (trust) => {
    setSelectedTrustMap(() => {
      const currentList = selectedTrustMap[selectedCategory] || [];
      const updatedList = currentList.includes(trust?.name)
        ? currentList.filter((t) => t !== trust?.name)
        : [...currentList, trust?.name];

      const newMap = {
        team_member: selectedCategory === "team_member" ? updatedList : [],
        team_leader: selectedCategory === "team_leader" ? updatedList : [],
      };

      setSecondaryItems?.(newMap);
      return newMap;
    });
  };

  const clearAll = () => {
    setSelectedTrustMap((prev) => ({
      ...prev,
      [selectedCategory]: [],
    }));
    setSecondaryItems?.([]);
    setError("");
  };

  const applyFilters = () => {
    setError("");
    setOpen(false);
    setRefresh((prev) => !prev);
  };

  const handleSelectAll = () => {
    const updatedList = [...selectedFilterList];
    const newMap = {
      team_member: selectedCategory === "team_member" ? updatedList : [],
      team_leader: selectedCategory === "team_leader" ? updatedList : [],
    };
    setSelectedTrustMap(newMap);
    setSecondaryItems?.(updatedList);
    setError("");
  };

  useEffect(() => {
    if (analyse_filters?.length) {
      const matched = analyse_filters?.find(
        (item) => item?.name === selectedCategory
      );
      setSelectedFilterList(matched?.filters || []);
    } else {
      setSelectedFilterList([]);
    }

    setSecondaryItems?.(selectedTrustMap[selectedCategory] || []);
    setError("");
  }, [analyse_filters, selectedCategory]);

  return (
    <Modal
      open={open}
      closeIcon={false}
      className="chart-filter-modal"
      footer={null}
      onCancel={() => setOpen(false)}
    >
      <div className="custom-dropdown chart-filter-content">
        <div className="filter-header">
          <div>
            <h2>Drill Down</h2>
            <div className="filter-actions-top">
              <Button onClick={clearAll} type="text">
                Clear all
              </Button>
              <Button onClick={applyFilters} type="primary">
                Apply
              </Button>
              <img
                src={crossIcon}
                alt="Close"
                height={15}
                width={15}
                onClick={() => setOpen(false)}
              />
            </div>
          </div>
          <Input
            prefix={<img src={searchIcon} alt="icon" />}
            placeholder="Search"
            allowClear
          />
        </div>

        <div className="status-line">
          <div>Category</div>
          <div>
            Select{" "}
            {selectedCategory === "team_member" ? "Team Member" : "Team Leader"}
          </div>
        </div>

        <div className="filter-body seperate-filter-body">
          <div className="filter-categories">
            {categories.map((cat) => (
              <Button
                key={cat.value}
                className={selectedCategory === cat.value ? "active" : ""}
                onClick={() => setSelectedCategory(cat.value)}
                block
              >
                {cat.title}
              </Button>
            ))}
          </div>

          <div className="filter-metrics seperate-filter">
            <div className="select-all">
              <button onClick={handleSelectAll}>Select All</button>
            </div>

            <div className="trust-list">
              {selectedFilterList?.map((trust) => (
                <div key={trust?.name} className="trust-item">
                  <Checkbox
                    checked={selectedTrustMap[selectedCategory]?.includes(
                      trust?.name
                    )}
                    onChange={() => toggleTrust(trust)}
                  >
                    {trust?.name}
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}


      </div>
    </Modal>
  );
};

export default ChartFilterModal;
